import { Sparkles } from "lucide-react";

// Widths of the "text" lines on the illustrated resume page.
const LINES = ["85%", "60%", "92%", "70%", "88%", "55%", "80%"];

// A small resume page whose lines draw themselves in, used on loading screens.
export default function ResumeDocAnimation({ size = "md" }: { size?: "sm" | "md" }) {
  const box = size === "sm" ? "h-28 w-20 p-2.5" : "h-40 w-32 p-4";
  return (
    <div className="relative mx-auto w-fit" aria-hidden="true">
      <div className={`${box} rounded-lg border border-gray-200 bg-white shadow-lg`}>
        <div className="mb-2 h-2.5 w-1/2 rounded bg-gradient-to-r from-blue-600 to-purple-600" />
        <div className="mb-3 h-1.5 w-1/3 rounded bg-indigo-200" />
        <div className="space-y-1.5">
          {LINES.map((width, i) => (
            <div
              key={i}
              className="fmr-write-line h-1.5 rounded bg-gray-200"
              style={{ width, animationDelay: `${i * 0.3}s` }}
            />
          ))}
        </div>
      </div>
      <Sparkles className="absolute -right-3 -top-3 h-6 w-6 text-purple-500 motion-safe:animate-pulse" />
    </div>
  );
}
